import { createFeatureSelector, createSelector } from '@ngrx/store';

import { FaceDetectionState } from '../state/face-detection.state';

export const selectFaceDetectionState =
  createFeatureSelector<FaceDetectionState>('faceDetection');

export const selectUserSnapshot = createSelector(
  selectFaceDetectionState,
  (state: FaceDetectionState) => state?.userSnapshotBase64Image,
);

export const selectFaceDetectionResponse = createSelector(
  selectFaceDetectionState,
  (state: FaceDetectionState) => ({
    isFaceDetected: state.isFaceDetected,
    isKnownFace: state.isKnownFace,
    knownFaceConfidence: state.knownFaceConfidence,
  }),
);

export const selectIsFaceComparisonLoading = createSelector(
  selectFaceDetectionState,
  (state: FaceDetectionState) => state.isFaceComparisonLoading,
);

export const selectIsKnownFace = createSelector(
  selectFaceDetectionState,
  selectIsFaceComparisonLoading,
  (state: FaceDetectionState, isLoading: boolean | undefined) => {
    return isLoading === false && state.isKnownFace === true;
  },
);
